import fetch from "auth/FetchInterceptor";

const APKFAS1Service = {};

APKFAS1Service.getApkFasService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customerid: data.customerid || "",
    facilityid: data.facilityid || "",
  });

  return fetch({
    url: `/APKFAS1/search?${params.toString()}`,
    method: "get",
  });
};

APKFAS1Service.getApkFasItemService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customerid: data.customerid || "",
    facilityid: data.facilityid || "",
  });

  return fetch({
    url: `/APKFAS1/search?${params.toString()}`,
    method: "get",
  });
};

APKFAS1Service.getFacilityDoc = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
  });

  return fetch({
    url: `/APKFAS1/facilityDoc?${params.toString()}`,
    method: "get",
  });
};

APKFAS1Service.posAPKFAS1Service = function (data) {
  return fetch({
    url: `/APKFAS1/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

APKFAS1Service.putAPKFAS1Service = function (data) {
  return fetch({
    url: "/APKFAS1/edit",
    method: "put",
    headers: {
      "x-requestId": data?.fasId,
    },
    data: data?.data,
  });
};

// APKFAS2

APKFAS1Service.getEditApkFas2Service = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
  });

  return fetch({
    url: `/APKFAS2/getedit?${params.toString()}`,
    method: "get",
  });
};

APKFAS1Service.posAPKFAS2Service = function (data) {
  return fetch({
    url: `/APKFAS2/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

APKFAS1Service.putAPKFAS2Service = function (data) {
  return fetch({
    url: `/APKFAS2/edit`,
    method: "put",
    headers: {
      "x-requestId": data?.fasId,
    },
    data: data?.data,
  });
};

// end APKFAS2
// APKFAS3
APKFAS1Service.posAPKFAS3Service = function (data) {
  return fetch({
    url: `/APKFAS3/add`,
    method: "post",
    headers: {},
    data: data,
  });
};


APKFAS1Service.getEditApkFas3Service = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    facilityid: data.facilityid || "",
  });

  return fetch({
    url: `/APKFAS3/getedit?${params.toString()}`,
    method: "get",
  });
};

// end APKFAS3

APKFAS1Service.posAPKFAS4Service = function (data) {
  return fetch({
    url: `/APKFAS4/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

APKFAS1Service.posCheckPercentageService = function (data) {
  return fetch({
    url: `/APKFAS4/check-percentage`,
    method: "post",
    data: data,
  });
};

APKFAS1Service.posAPKFAS5Service = function (data) {
  return fetch({
    url: `/APKFAS5/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

APKFAS1Service.posSurfeyAPKFAService = function (data) {
  return fetch({
    url: `/SurveyFacility/add`,
    method: "post",
    headers: {},
    data: data,
  });
};

APKFAS1Service.getCustomerSearchService = function (data) {
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;

  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customerid: data.customerid || "",
    code: data.code || "",
    name: data.name || "",
    idNumber: data.idNumber || "",
    address: data.address || "",
    birthDate: data.birthDate || "",
    motherMaidenName: data.motherMaidenName || "",
    phonenumber: data.phonenumber || "",
  });

  return fetch({
    url: `/APKFAS1/customerSearch?${params.toString()}`,
    method: "get",
  });
};

APKFAS1Service.getSurveyFacilityService = function (data) {
  
  const dataIndex = data.pageIndex || 0;
  const decrementIndex = dataIndex === 0 ? 0 : dataIndex - 1;
  
  const params = new URLSearchParams({
    pageSize: data.pageSize || 10,
    pageIndex: decrementIndex,
    customerid: data.customerId || "",
    facilityid: data.facilityId || "",
    status: "DE"
  });
 

  return fetch({
    url: `/SurveyFacility/searchList?${params.toString()}`,
    method: "get",
  });
};

export default APKFAS1Service;
